import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Alert, AlertTitle, AlertDescription } from '../ui/alert';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole = null, allowedRoles = [] }) => {
  const { isAuthenticated, hasRole, user } = useAuth();
  const location = useLocation();

  // First check if user is authenticated
  if (!isAuthenticated()) {
    return <Navigate to="/" state={{ from: location.pathname }} replace />;
  }

  // Then check for required roles if specified
  if (requiredRole || allowedRoles.length > 0) {
    const hasRequiredRole = requiredRole ? hasRole(requiredRole) : false;
    const hasAllowedRole = allowedRoles.length > 0 ? allowedRoles.some(role => hasRole(role)) : false;

    if (!hasRequiredRole && !hasAllowedRole) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <Alert variant="destructive" className="max-w-md">
            <AlertTitle>Access Denied</AlertTitle>
            <AlertDescription>
              You do not have the required permissions to access this page.
            </AlertDescription>
          </Alert>
        </div>
      );
    }
  }

  return children;
};

export default ProtectedRoute;